module.exports = __webpack_public_path__ + "img/longate-bonus-bg-desktop.a56c127d.jpg";